<script>
import { mapState, mapActions } from "vuex";
import DistribucionAsientos from "@/components/DistribucionAsientos.vue";
import Spinner from "@/components/intranet/Spinner.vue";

export default {
  name: "TransporteFormulario",
  components: {
    DistribucionAsientos,
    Spinner,
  },

  data() {
    return {
      fecha_viaje: "",
      id_empresa: this.$ls.get("user").id_empresa_fk,
      //FF
      form_success: false,
      formulario: {
        step: 1,
        //Input
        telefono: "",
        email: "",
        //Select
        turno: "",
        team: "",
        tipo_transporte: "",
        tramo: "",
        //check
        asiento: "",
      },
      arrayTramos: [],
      //FIX para que funcione tramos como esta en Back.
      tramo_para_back: "",
      show_spinner: false,
      planificacion_actual: {},
      detailsIda: false,
      detailsVuelta: false,
      tramosVuelta: [],
      vuelta: null,
      ida_vuelta_radio: false,
      show_ida_vuelta_radio: false,
      asientoVuelta: null,
    };
  },

  computed: {
    ...mapState("TransporteModule", [
      "listMenuIntranet",
      "getOnePlanificacionID",
      "usuario",
      "turnos",
      "teams",
      "tipoTransporte",
      "GetTramosApp",
      "planificaciones",
      "tipoIdaVuelta",
    ]),
    validationStepOne() {
      return {
        phone: !!this.formulario.telefono,
        email: !!this.formulario.email,
      };
    },
    validationStepTwo() {
      return {
        tipo_transporte: !!this.formulario.tipo_transporte,
        tramo: !!this.formulario.tramo,
        asiento: !!this.formulario.asiento,
        // Validación mejorada para ida y vuelta
        vuelta: this.ida_vuelta_radio
          ? !!this.vuelta &&
          // Verifica que haya seleccionado tramo de vuelta
          !!this.asientoVuelta &&
          // Verifica que haya seleccionado asiento de vuelta
          this.vuelta.asientos?.some(
            (a) => a.id_asiento === this.asientoVuelta.id_asiento
          ) // Verifica que el asiento seleccionado sea válido
          : true,
      };
    },
    isValidStepOne() {
      let validation = this.validationStepOne;
      return Object.keys(validation).every(function (keys) {
        return validation[keys];
      });
    },
    isValidStepTwo() {
      let validation = this.validationStepTwo;
      return Object.keys(validation).every(function (keys) {
        return validation[keys];
      });
    },
  },
  async created() {
    try {
      // Ejecutar las peticiones en paralelo
      await Promise.all([
        this.getIdPlanificacion(),
        this.getUser(),
        this.getTransporte(),
      ]);

      let index_planificacion_actual = this.planificaciones.findIndex(
        (planificacion) =>
          planificacion.id_planificacion == this.$route.params.id_planificacion
      );

      this.planificacion_actual =
        this.planificaciones[index_planificacion_actual];
      await this.getTipoTransporte({
        id_empresa: this.id_empresa,
        id_planificacion: this.getOnePlanificacionID.id_planificacion,
        fecha_viaje: this.planificacion_actual.fecha_viaje,
      });
    } catch (error) {
      console.error("Error en created:", error);
      // Aquí podrías manejar el error, por ejemplo mostrando un toast
    }
  },
  watch: {
    "formulario.tramo": {
      async handler(newValue) {
        if (newValue) {
          this.clenaVuelta();
          this.getTramosAppVuelta({
            idEmpresa: this.id_empresa,
            idPlanificacion: this.$route.params.id_planificacion,
            fechaViaje: newValue.fecha_viaje,
            idTipoTransporte: this.formulario.tipo_transporte.id_tipo,
            idTramoIda: newValue.id,
          }).then(async (ts) => {
            if (ts.length > 0) this.show_ida_vuelta_radio = true;
            this.tramosVuelta = await this.formatTramo(ts);
          });
        }
      },
    },
    "formulario.tipo_transporte"() {
      this.formulario.tramo = "";
      this.getTramosEmpresa();
    },
    tipoTransporte: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length === 1) {
          this.formulario.tipo_transporte = newValue[0];
        }
      },
    },
  },
  methods: {
    ...mapActions("TransporteModule", [
      "getPlanificacionId",
      "getUsuario",
      "getTipoTransporte",
      "getTramos",
      "getTipoIdaVuelta",
      "getTramosAppVuelta",
      "crearInscripcion",
      "getPlanificacionTransporte",
    ]),

    clenaVuelta() {
      this.show_ida_vuelta_radio = false;
      this.ida_vuelta_radio = false;
      this.tramosVuelta = [];
      this.vuelta = null;
      this.asientoVuelta = null;
    },

    vueltaRadioHandle() {
      this.vuelta = null;
      this.asientoVuelta = null;
    },

    async getIdPlanificacion() {
      let data_ = {
        id_empresa: this.id_empresa,
        id_planificacion: this.$route.params.id_planificacion,
      };
      const res = await this.getPlanificacionId(data_);
      this.fecha_viaje =
        res.tranpsorte_planificacion_detalle.fecha_inicio_ejecucion;
    },

    async getTransporte() {
      await this.getPlanificacionTransporte({ id_empresa: this.id_empresa });
    },

    async getUser() {
      let data_ = {
        id_empresa: this.id_empresa,
        id_usuario: this.$ls.get("user").id_usuario,
      };
      const resUsuario = await this.getUsuario(data_);
      this.formulario.email = resUsuario.correo;
      this.formulario.turno = resUsuario.turno;
      this.formulario.telefono = resUsuario.telefono_movil;
    },

    async getTurno() {
      await this.getTurnos({ id_empresa: this.id_empresa });
    },

    async getTeam() {
      await this.getTeams({ id_empresa: this.id_empresa });
    },

    async formatTramo(toFormat) {
      return toFormat.map((t) => {
        let date = new Date(t.fecha_viaje + "T00:00:00");
        let month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let year = date.getFullYear();
        let fecha = year + "-" + month + "-" + day;
        return {
          ...t,
          id: t.id_tramo,
          label: `${t.transporte_lista_destino.nombre_origen} -> ${t.transporte_lista_destino.nombre_destino} (${fecha})`,
          transporte_ida_vuelta: t.transporte_ida_vuelta,
          asientos: t.asientos,
        };
      });
    },

    detailsIdaHandle({ newState }) {
      this.detailsIda = newState == "open";
    },

    detailsVueltaHandle({ newState }) {
      this.detailsVuelta = newState == "open";
    },

    async getTramosEmpresa() {
      let index_planificacion_actual = this.planificaciones.findIndex(
        (planificacion) =>
          planificacion.id_planificacion == this.$route.params.id_planificacion
      );
      this.fecha_viaje =
        this.planificaciones[index_planificacion_actual].fecha_viaje;
      let data_ = {
        id_empresa: this.id_empresa,
        id_planificacion: this.$route.params.id_planificacion,
        fecha_viaje: this.fecha_viaje,
        id_tipo_transporte: this.formulario.tipo_transporte.id_tipo,
        is_principal: "1",
        id_tramo_padre: "0",
      };
      await this.getTramos(data_);
      this.arrayTramos = await this.formatTramo(this.GetTramosApp);
    },

    toDate(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);
      return this.capitalizeFirstLetter(
        newDate.toLocaleString("es-Cl", {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      ).replace(/,/g, "");
    },

    async sendSolicitud() {
      this.show_spinner = true;
      let data_ = {
        id_empresa: this.id_empresa,
        id_usuario: this.$ls.get("user").id_usuario,
        tramos: this.tramo_para_back,
      };
      const resInscripcion = await this.crearInscripcion(data_);
      if (resInscripcion) {
        if (resInscripcion.errors && resInscripcion.errors.length > 0) {
          this.toastExistingRegistrationWarning();
        } else {
          this.form_success = true;
        }
      } else {
        this.toastGenericError();
      }
      this.show_spinner = false;
    },

    // Permite ciertos caracteres para inputs de telefono
    handleKeyPress(event) {
      const allowedKeys = [9, 13, 32, 43, 45]; // tab, enter, space, plus sign, dash sign
      const keyCode = event.keyCode;

      if (
        (keyCode >= 48 && keyCode <= 57) || // numbers
        allowedKeys.includes(keyCode)
      ) {
        // allowed keys
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    },

    handleVuelta() {
      if (this.formulario.asiento) {
        const asientoVuelta = this.vuelta.asientos.find(
          (a) => a.nombre_asiento === this.formulario.asiento.nombre_asiento
        );
        if (asientoVuelta) this.seleccionarAsientoVuelta(asientoVuelta);
      }

    },

    seleccionarAsiento(selected_asiento) {
      this.formulario.asiento = selected_asiento;

      this.formulario.tramo.asientos.forEach((seat) => {
        if (seat.disponible) {
          seat.selected = false;
        } else {
          if (seat.selected) {
            seat.selected = false;
            seat.disponible = true;
          }
        }
      });
      const index = this.formulario.tramo.asientos.findIndex(
        (t) => t.id_asiento === selected_asiento.id_asiento
      );
      if (index != -1) {
        if (!this.formulario.tramo.asientos[index].disponible) return;
        this.formulario.tramo.asientos[index].selected = true;
        this.formulario.asiento = this.formulario.tramo.asientos[index];
      }
    },

    seleccionarAsientoVuelta(selected_asiento) {
      // Primero limpiamos las selecciones previas
      this.vuelta.asientos = this.vuelta.asientos.map((seat) => ({
        ...seat,
        selected: false,
      }));

      // Encontramos y actualizamos el asiento seleccionado
      const index = this.vuelta.asientos.findIndex(
        (t) => t.id_asiento === selected_asiento.id_asiento
      );

      if (index !== -1 && this.vuelta.asientos[index].disponible) {
        // Actualizamos el asiento seleccionado
        this.vuelta.asientos[index] = {
          ...this.vuelta.asientos[index],
          selected: true,
        };

        // Actualizamos la referencia al asiento seleccionado
        this.asientoVuelta = this.vuelta.asientos[index];
        // Forzamos la actualización del componente
        this.vuelta = { ...this.vuelta };
      }
    },

    eventTramoParaBack() {
      let arr = [
        {
          id_tramo: this.formulario.tramo.id,
          id_asiento: this.formulario.asiento.id_asiento,
          id_tramo_conexion: null,
          id_asiento_conexion: null,
          id_ida_vuelta:
            this.formulario.tramo.transporte_ida_vuelta.id_ida_vuelta,
        },
      ];
      if (this.ida_vuelta_radio) {
        arr.push({

          id_tramo: this.vuelta.id,
          id_asiento: this.formulario.asiento.id_asiento,
          id_tramo_conexion: null,
          id_asiento_conexion: null,
          id_ida_vuelta:
            this.asientoVuelta.id_ida_vuelta,
        })
      }
      this.tramo_para_back = arr
    },

    finalizarInscripcion() {
      this.$router.push("/transporte");
    },

    toastExistingRegistrationWarning() {
      this.$toast.open({
        message:
          "Ya has hecho una solicitud para este viaje. Si deseas modificarla por favor ponte en contacto con el Administrador.",
        type: "warning",
        duration: 5000,
        position: "top-right",
      });
    },
  },
};
</script>

<template>
  <section id="transporte-form">
    <Spinner v-if="show_spinner" />

    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main">
          <font-awesome-icon icon="fa-solid fa-pen-to-square" class="main-color"></font-awesome-icon>
          Inscripción
        </h1>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/transporte">
                <font-awesome-icon icon="fa-solid fa-bus-simple"></font-awesome-icon>
                Transporte
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">Inscripción</li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          ¡Disfruta los beneficios que tenemos para ti y tu familia! Conócelos y
          solicítalos aquí.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-lg-6">
                <h4 class="font-700 text-secondary" :class="[formulario.step === 1 ? 'color-main' : '']">
                  Selecciona tu información
                </h4>
                <div class="card" :class="[formulario.step === 1 ? 'border-main' : '']">
                  <div class="card-body d-flex flex-column mh-form">
                    <div class="row flex-grow-1">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-4">
                            <h5 class="font-main h5-custom text-secondary mb-0">
                              Período
                            </h5>
                          </div>
                          <div class="col-8 text-end">
                            <h6 class="font-main mb-0 text-secondary" :class="[
                              formulario.step === 1 ? 'color-main' : '',
                            ]">
                              {{ toDate(planificacion_actual.fecha_viaje) }}
                            </h6>
                          </div>
                        </div>
                        <hr class="border-bottom mb-3 mt-1" />
                        <div class="alert alert-light border-warning text-center text-secondary">
                          Recuerda que tienes hasta el
                          <strong>
                            {{
                              toDate(planificacion_actual.fecha_fin_inscripcion)
                            }}
                          </strong>
                          para inscribirte.
                        </div>
                        <div class="row mb-3">
                          <div class="col-12">
                            <h5 class="font-main h5-custom border-bottom text-secondary">
                              Valida tu información de contacto
                            </h5>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-lg-6 mb-3">
                            <label for="select-2" class="form-label text-secondary">
                              Teléfono
                            </label>
                            <input type="text" class="form-control input-custom" v-model="formulario.telefono"
                              v-on:keypress="handleKeyPress($event)" />
                          </div>
                          <div class="col-12 col-lg-6 mb-3">
                            <label for="select-2" class="form-label text-secondary">
                              Mail
                            </label>
                            <input type="email" class="form-control input-custom" v-model="formulario.email" />
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-12">
                            <h5 class="font-main h5-custom border-bottom text-secondary">
                              Información turno
                            </h5>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-lg-6 mb-3">
                            <input type="text" readonly="readonly" disabled="disabled" class="form-control input-custom"
                              :value="`Tu turno es: ${formulario.turno[0]?.nombre_turno}`" />
                          </div>
                          <!-- <div class="col-12 col-lg-6 mb-3">
                            <label for="select-2" class="form-label text-secondary">
                                        Team
                                      </label>
                            <v-select :options="teams" v-model="formulario.team" label="nombre_team" placeholder="Seleccionar" class="vue-select" :clearable="false">
                            </v-select>
                          </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn-custom btn-custom-main" data-bs-toggle="collapse"
                          data-bs-target="#formulario-2" aria-expanded="false" aria-controls="collapseWidthExample"
                          v-if="formulario.step === 1" @click="formulario.step = 2" :disabled="!isValidStepOne">
                          Siguiente
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="formulario.step === 2" class="col-12 col-lg-6">
                <h4 class="font-700 text-secondary color-main">
                  Solicita tu transporte
                </h4>
                <div class="card border-main">
                  <div class="card-body d-flex flex-column mh-form">
                    <div class="row flex-grow-1">
                      <div class="col-12">
                        <div class="row mb-3">
                          <div class="col-12">
                            <h5 class="font-main h5-custom border-bottom text-secondary">
                              Configura tu viaje
                            </h5>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 mb-3">
                            <label for="select-2" class="form-label text-secondary">
                              Tipo de transporte
                            </label>
                            <v-select :options="tipoTransporte" v-model="formulario.tipo_transporte"
                              label="nombre_transporte" placeholder="Seleccionar" class="vue-select" :clearable="false">
                            </v-select>
                          </div>
                        </div>
                        <template v-if="formulario.tipo_transporte">
                          <div class="row">
                            <div class="col-12 mb-3">
                              <label for="select-2" class="form-label text-secondary">
                                Tramo
                              </label>
                              <v-select :options="arrayTramos" v-model="formulario.tramo" placeholder="Seleccionar"
                                class="vue-select" :clearable="false">
                              </v-select>
                            </div>
                          </div>
                          <div v-if="formulario.tramo.asientos" class="mt-3">
                            <div class="alert alert-light border d-flex justify-content-between align-items-center"
                              style="height: 60px">
                              <span class="text-secondary">
                                Salida:
                                {{ formulario.tramo.hora_viaje + " hrs." }}
                              </span>
                              <span>
                                <div v-if="show_ida_vuelta_radio"
                                  class="form-check form-switch form-switch-custom form-switch-custom-reverse">
                                  <input class="form-check-input" type="checkbox" id="switch-ida-vuelta"
                                    @change="vueltaRadioHandle" v-model="ida_vuelta_radio" />
                                  <label class="form-check-label link-cursor" for="switch-ida-vuelta">
                                    <font-awesome-icon icon="fa-solid fa-arrow-right-arrow-left"
                                      class="pe-1"></font-awesome-icon>
                                    Ida y vuelta
                                  </label>
                                </div>
                              </span>
                            </div>
                          </div>
                          <details open v-if="formulario.tramo.asientos" class="row" @toggle="detailsIdaHandle">
                            <summary class="col-lg-12 mb-3">
                              <h5
                                class="font-main h5-custom border-bottom text-secondary d-flex justify-content-between">
                                <span>
                                  <span v-if="formulario.asiento" class="bg-green color-white rounded-1 px-1 me-2">{{
                                    formulario.asiento.nombre_asiento }}
                                  </span>
                                  Selecciona tu asiento
                                </span>

                                <span class="badge mb-2">
                                  <font-awesome-icon icon="fa-solid fa-chevron-up" class="color-green" :style="{
                                    transform: detailsIda
                                      ? 'rotate(0deg)'
                                      : 'rotate(180deg)',
                                  }">
                                  </font-awesome-icon>
                                </span>
                              </h5>
                            </summary>
                            <div class="col-12 overflow-300 scroll">
                              <DistribucionAsientos :asientos="formulario.tramo.asientos" :editable="true"
                                @clickAsiento="seleccionarAsiento" />
                            </div>
                          </details>
                          <div class="row" v-if="ida_vuelta_radio">
                            <div class="col-12 mb-3">
                              <label for="select-2" class="form-label text-secondary">
                                Tramo vuelta
                              </label>
                              <v-select :options="tramosVuelta" v-model="vuelta" placeholder="Seleccionar"
                                class="vue-select" :clearable="false" @input="handleVuelta">
                              </v-select>
                            </div>
                          </div>
                          <details open v-if="ida_vuelta_radio && vuelta !== null" class="row"
                            @toggle="detailsVueltaHandle">
                            <summary class="col-lg-12 mb-3">
                              <h5
                                class="font-main h5-custom border-bottom text-secondary d-flex justify-content-between">
                                <span>
                                  <span v-if="asientoVuelta" class="bg-red color-white rounded-1 px-2 me-2">{{
                                    asientoVuelta.nombre_asiento }}
                                  </span>
                                  Selecciona tu asiento de vuelta
                                </span>

                                <span class="badge mb-2">
                                  <font-awesome-icon icon="fa-solid fa-chevron-up" class="color-green" :style="{
                                    transform: detailsVuelta
                                      ? 'rotate(0deg)'
                                      : 'rotate(180deg)',
                                  }">
                                  </font-awesome-icon>
                                </span>
                              </h5>
                            </summary>
                            <div class="col-12 overflow-300 scroll">
                              <DistribucionAsientos :asientos="vuelta.asientos" :editable="true"
                                @clickAsiento="seleccionarAsientoVuelta" />
                            </div>
                          </details>
                        </template>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 d-flex justify-content-end mt-3">
                        <button class="btn btn-custom btn-custom-main" @click="eventTramoParaBack()"
                          data-bs-toggle="modal" data-bs-target="#modal-confirmar-transp" :disabled="!isValidStepTwo">
                          Siguiente
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--MODAL-->
    <div class="modal fade" id="modal-confirmar-transp" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between border-0 pb-0">
            <h4 class="font-700 color-main">Confirma tu solicitud</h4>
            <a class="h3 mb-0 link-secondary" href="javascript:" data-bs-dismiss="modal">
              <font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>
            </a>
          </div>
          <div class="modal-body">
            <ul v-if="!form_success" class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between text-secondary">
                <span> Tipo de viaje </span>
                <h5 class="mb-0 h5-custom">
                  <span class="badge bg-green">
                    Ida
                  </span>
                </h5>
              </li>
              <li class="list-group-item d-flex justify-content-between text-secondary">
                <span> Fecha </span>
                <span>{{
                  toDate(
                    formulario.tramo.fecha_viaje
                  )
                }}
              </span>
              </li>
              <li class="list-group-item d-flex justify-content-between text-secondary">
                <span> Transporte </span>
                <span>
                  {{ formulario.tipo_transporte.nombre_transporte }}
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between text-secondary">
                <span> Tramo </span>
                <span>
                  {{ formulario.tramo.label }}
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between text-secondary">
                <span> Asiento </span>
                <h5 class="mb-0 h5-custom">
                  <span class="text-secondary">
                    {{ formulario.asiento.nombre_asiento }}
                  </span>
                </h5>
              </li>
              <template v-if="ida_vuelta_radio">
                <li class="list-group-item d-flex justify-content-between text-secondary">
                  <span> Tipo de viaje </span>
                  <h5 class="mb-0 h5-custom">
                    <span class="badge bg-red">
                      Vuelta
                    </span>
                  </h5>
                </li>
                <li class="list-group-item d-flex justify-content-between text-secondary">
                  <span> Fecha </span>
                  <span>{{
                    toDate(
                      vuelta?.fecha_viaje
                    )
                    }}
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between text-secondary">
                  <span> Transporte </span>
                  <span>
                    {{ formulario?.tipo_transporte?.nombre_transporte }}
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between text-secondary">
                  <span> Tramo </span>
                  <span>
                    {{ vuelta?.label }}
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between text-secondary">
                  <span> Asiento </span>
                  <h5 class="mb-0 h5-custom">
                    <span class="text-secondary">
                      {{ asientoVuelta?.nombre_asiento }}
                    </span>
                  </h5>
                </li>
              </template>
            </ul>

            <div v-if="form_success" class="row">
              <div class="col-12">
                <div class="alert alert-success text-center mb-0">
                  <font-awesome-icon icon="fa-solid fa-circle-check"></font-awesome-icon>
                  Tu Solicitud ha sido <strong>ingresada correctamente.</strong>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!form_success" class="modal-footer">
            <button type="button" class="btn btn-custom btn-custom-line-gray mw-150" data-bs-dismiss="modal">
              <font-awesome-icon icon="fa-solid fa-angle-left" class="pe-2"></font-awesome-icon>
              Volver
            </button>
            <a @click="sendSolicitud()" class="btn btn-custom btn-custom-main mw-150">
              <font-awesome-icon icon="fa-solid fa-check" class="pe-2"></font-awesome-icon>
              Confirmar
            </a>
          </div>
          <div v-if="form_success" class="modal-footer">
            <a data-bs-dismiss="modal" @click="finalizarInscripcion()" class="btn btn-custom btn-custom-main w-100">
              <font-awesome-icon icon="fa-solid fa-angle-left" class="pe-2"></font-awesome-icon>
              Volver a transporte
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
details {
  >summary {
    list-style: none;
    cursor: pointer;

    &::-webkit-details-marker {
      display: none;
    }
  }
}
</style>
